export default {
  label: "Mitarbeiter",
  stammdaten: {
    label: "Stammdaten",
  },
};
